const home = {
  title: "מרכז הפיקוד GAM",
  description: "לוח ניהול פרויקטים פנימי עבור G.A.M",
  openDashboard: "פתח דשבורד",
  workspaceName: "G.A.M — מרכז פיקוד",
  workspaceLabel: "סביבת עבודה",
  devDashboard: "דשבורד פיתוח",
  devDashboardDesc: "ניהול פרויקטים, עורך מסמכים, מפת סיפורים, ווידג'טים",
  clientManagement: "ניהול מערכות לקוחות",
  clientManagementDesc: "ניהול לקוחות, פורטלים, דוחות",
  adminDevLog: "לוג פיתוח ואדמין",
  adminDevLogDesc: "סטטוס מערכת, קומפוננטות, מעקב גרסאות",
  comingSoon: "בקרוב",
  active: "פעיל",
} as const;
export default home;
